import { graphClient } from '../../../graph-client'
import { GET_USERS_TASKS_HOSTS_DEFAULTS } from './gql'
import type { GetList } from './types'

class UserTaskHostDefaultService {
  async getList({ take = 20, skip = 0, ...params }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_USERS_TASKS_HOSTS_DEFAULTS,
      {
        ...params,
        skip: take * skip,
      },
    )
    return request?.getUsersTasksHostsDefaults
  }
}

export const userTaskHostDefaultService = new UserTaskHostDefaultService()
